<template>
  <div class="wrapper">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button v-if="searchStatus" status="my-orange" @click="searchStatus = false">隐藏查询</vxe-button>
        <vxe-button v-if="!searchStatus" status="my-orange" icon="fa fa-search" @click="searchStatus = true">查询</vxe-button>
      </template>
    </vxe-toolbar>
    <div v-if="searchStatus" class="search">
      <vxe-form title-align="right" title-width="120" title-colon :data="listQuery" @submit="handleSearch(true)" @reset="handleSearch(true, true)">
        <vxe-form-item title="类型" span="6">
          <vxe-select v-model="listQuery.orgType" placeholder="请选择类型" clearable>
            <vxe-option
              v-for="(item, index) in dict.org_type"
              :key="index"
              :label="item"
              :value="index"
            />
          </vxe-select>
        </vxe-form-item>
        <vxe-form-item title="名称" span="6">
          <vxe-input v-model="listQuery.name" placeholder="请输入名称" clearable />
        </vxe-form-item>
        <vxe-form-item title="状态" span="6">
          <vxe-select v-model="listQuery.status" placeholder="请选择状态" clearable>
            <vxe-option
              v-for="(item, index) in dict.sunCenterStatus"
              :key="index"
              :label="item"
              :value="index"
            />
          </vxe-select>
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <vxe-button type="submit" status="my-orange" icon="fa fa-check">应用</vxe-button>
          <vxe-button type="reset" status="my-orange" icon="fa fa-undo">重置</vxe-button>
        </vxe-form-item>
      </vxe-form>
    </div>
    <CustomList ref="CustomList" :columns="tableColumns" :list-query="listQuery" @getList="getList">
      <template slot="name" slot-scope="{row}">
        <el-link type="primary" :underline="false" @click="handleDetail(row)">
          {{ row.name }}
        </el-link>
      </template>
      <template slot="operating" slot-scope="{row}">
        <el-button v-permission="'AuditSumCenterPassButton'" size="small" type="text" @click="handlePass(row.id)">通过</el-button>
        <el-button v-permission="'AuditSumCenterRejectButton'" size="small" type="text" @click="handleRejectAudit(row.id, 2)">拒绝</el-button>
      </template>
    </CustomList>
    <el-dialog
      title="添加登录账号"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <CustomForm
        ref="CustomForm"
        :form-model="formModel"
        :form-items="formItem"
        :form-rules="formRules"
      />
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePassAudit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomList from '@/components/CustomList/index'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'
import { mapActions } from 'vuex'
import CustomForm from '@/components/CustomForm/index.vue'
export default {
  name: 'SumCenter',
  components: { CustomForm, CustomList, ...CustomTemplate },
  data() {
    return {
      searchStatus: false,
      auditStatusArray: { '-1': '隐藏', '0': '待审核', '1': '正常', '2': '拒绝' },
      dict: {
        org_type: {},
        sunCenterStatus: {}
      },
      listQuery: {
        hasTenant: true,
        auditStatus: 0
      },
      tableColumns: [
        {
          title: '名称',
          slot: 'name'
        },
        {
          prop: 'centStatusName',
          title: '状态'
        },
        {
          prop: 'nature',
          title: '性质'
        },
        {
          prop: 'operCompName',
          title: '运营企业'
        },
        {
          title: '操作',
          fixed: 'right',
          slot: 'operating',
          minWidth: 100
        }
      ],
      dialogVisible: false,
      formModel: {
        mainId: '',
        account: '',
        password: '',
        status: 1
      }
    }
  },
  computed: {
    formItem() {
      return {
        'account': {
          'elColSpan': 24,
          'component': 'CustomFormText',
          'label': '账号',
          'maxlength': 50
        },
        'password': {
          'elColSpan': 24,
          'component': 'CustomFormText',
          'label': '密码',
          'maxlength': 50
        }
      }
    },
    formRules() {
      return {
        account: [
          { required: true, message: '账号不能为空', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created() {
    this.getSysDictList('org_type')
    this.getSysDictList('sunCenterStatus')
  },
  methods: {
    ...mapActions(['getSysDictServe', 'getSumCenterList', 'auditAudit']),
    getSysDictList(typeCode) {
      this.getSysDictServe({ typeCode }).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.msg)
          return
        }
        res.data.forEach(res => {
          this['dict'][typeCode][res.dictPidVal] = res.dictDesc
        })
      })
    },
    handleSearch(resetCurrentPage = false, resetSearch = false) {
      if (resetSearch) {
        Object.assign(this.listQuery, this.$options.data.call(this).listQuery)
      }
      this.customListGetList(resetCurrentPage)
    },
    customListGetList(resetCurrentPage = false) {
      this.$refs.CustomList.getList(resetCurrentPage)
    },
    getList(params, callback) {
      this.getSumCenterList(params).then(response => {
        callback(response)
      }).catch(() => {})
    },
    handleDetail(row) {
      this.$router.push({
        name: 'SumCenterDetail',
        params: {
          type: 'detail',
          id: row.id
        },
        query: {
          type: 'detail',
          item: JSON.stringify(row),
          cmOrEntId: row.id
        }
      })
    },
    handlePass(mainId) {
      this.formModel.mainId = mainId
      this.formModel.account = ''
      this.formModel.password = ''
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.CustomForm.$refs.form.clearValidate()
      })
    },
    handlePassAudit() {
      this.requestApi(this.formModel)
      this.dialogVisible = false
    },
    handleRejectAudit(mainId) {
      this.$confirm('确认拒绝吗？', '', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showInput: true
      }).then(data => {
        let reason = ''
        if (typeof data === 'object' && 'value' in data) {
          reason = data.value
        }
        this.requestApi({ reason, mainId, status: 2 })
      }).catch(() => {})
    },
    requestApi(params) {
      params['type'] = 1
      this.auditAudit(params).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('操作成功')
        this.handleSearch(true)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper{
    overflow: auto;
  }
</style>
